import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { DialogData, RadioEventData } from '../../model/data.model';
import productConfig from '../../life-config/productCodeConfig.json';

@Component({
    selector: 'app-quote-premium-breakup',
    templateUrl: './quote-premium-breakup.component.html',
    styleUrls: ['./quote-premium-breakup.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class QuotePremiumBreakupComponent implements OnInit {

    radioEventData: RadioEventData;
    premBreakupRes: any;
    classNameObtained: string;
    quotesInitialInfo: any;
    productConf = productConfig.product_type;
    basePremium: any;
    grossPremium: any;
    tax: any;
    riderList: any;

    constructor(
        private dialogRef: MatDialogRef<QuotePremiumBreakupComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {

        // Getitng response from modal data

        this.premBreakupRes = data['editProposalModal'];
        this.quotesInitialInfo = data['proposalInfo'];
        if (data['editProposalModal']['riders'] && data['editProposalModal']['riders'].length > 0){
            this.riderList = data['editProposalModal']['riders'];
        }

        /**
         * check for add ons rider if available it will be dispalyed with addons
         * handling totoal tax depenf on the condition of add ons rider
         */
        if(data['editProposalModal'] && data['editProposalModal']['riders'] &&  data['editProposalModal']['riders'].length > 0 ){

            this.tax =this.premBreakupRes['total_tax'];
            this.basePremium =   this.premBreakupRes['base_premium'];
            this.grossPremium = this.premBreakupRes['gross_premium'];


        } else{

            this.basePremium =   this.premBreakupRes['base_premium'];
            this.grossPremium = this.premBreakupRes['gross_premium'];
            if (this.premBreakupRes['total_tax']){
                this.tax = this.premBreakupRes['total_tax'];
            } else {

                this.tax = this.premBreakupRes['tax'];
            }
        }




    }



    ngOnInit() {
    }

}



